// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"717caf6e","239":"1d1b345f","667":"ba808668"}[chunkId] + ".chunk.js";
};